export default function (text) {
    if (text == undefined) {
        return 0;
    }

    return (text.match(/(^|\W)(#[a-zA-Z\d][\w-]*)/g) || []).length;
};